import React, {useState} from 'react'
import {KTCard, KTCardBody, KTSVG, QUERIES} from '../../../../../_metronic/helpers'
import {useMutation, useQuery} from 'react-query'
import {fetchLinks} from '../scrapping-table/core/_requests'
import {useQueryClient} from 'react-query'
import {useNavigate} from 'react-router-dom'
import {toast, ToastContainer} from 'react-toastify'

export const useGetFetchQuery = (name: any) => {
  const queryClient = useQueryClient()
  return queryClient.getQueryData(name)
}

interface InputCardProps {
  tableLoading: boolean
  handleTableLoading: () => void
  searchTerm:  File[];
}

const InputCard: React.FC<InputCardProps> = ({tableLoading, handleTableLoading,searchTerm}) => {
  const redirectToRoute = () => {
    navigate(-1)
  } 
  const navigate = useNavigate()

  
  
  return (
    <div className='d-flex flex-column flex-center text-center mt-15'>
      <div className='card card-flush w-lg-950px'>
        <KTCard className='pt-5 pb-5'>
          <KTCardBody className='py-0'>
            <div className='d-flex align-items-center position-relative'>
              <div onClick={redirectToRoute}>
                {' '}
                <KTSVG
                  path='/media/icons/duotune/general/gen001.svg'
                  className='svg-icon-1 me-10'
                />
              </div>
              <div  className='form-control form-control-solid ps-18 pt-3 pb-3 me-5'>Please upload your PDF File</div>
              <button
                className='btn btn-md btn-primary'
                onClick={handleTableLoading}
                disabled={searchTerm.length==0}
              >
                {tableLoading ? (
                  <div className='spinner-border spinner-border-sm' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </div>
                ) : (
                  'Upload'
                )}
              </button>
            </div>
          </KTCardBody>
        </KTCard>
      </div>
    </div>
  )
}

export {InputCard}
